import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import styled from 'styled-components';
import CS from '@/styles/componentStyled';
import TitleTextBox from '@/component/TitleTextBox';
import {
  dashboardFacilityRecoil,
  dashboardRegionRecoil,
} from '@/atom/DashboardAtom';
import Chart from 'react-apexcharts';

const ModelChart = () => {
  const dashboardFacilityState = useRecoilValue(dashboardFacilityRecoil);

  const [pieLabel, setPieLabel] = useState<string[]>([]);
  const [pieValue, setPieValue] = useState<number[]>([]);

  const pieSerise = pieValue;
  const pieOptions: ApexCharts.ApexOptions = {
    chart: {
      type: 'pie',
    },
    labels: pieLabel,
    tooltip: {
      enabled: true,
      shared: true,
      intersect: false,
    },
  };

  useEffect(() => {
    if (dashboardFacilityState) {
      setPieLabel(Object.keys(dashboardFacilityState.datas));
      setPieValue(Object.values(dashboardFacilityState.datas));
    }
  }, [dashboardFacilityState]);

  return (
    <>
      <CntBox className="flex fdc">
        <TitleTextBox text="모델별 설치 현황" />
        <div className="chart-box">
          <Chart
            options={pieOptions}
            series={pieSerise}
            type="pie"
            height="100%"
          />
        </div>
      </CntBox>
    </>
  );
};

export default ModelChart;

export const CntBox = styled(CS.CntBoxType1)`
  flex: 1 1 0%;
  gap: 10px;
`;
